import { SyncOutlined } from "@mui/icons-material"
import { VyneButton } from "@vynedental/design-system"
import { Tooltip } from "antd"
import { Labels } from "trellis:constants/labels"
import { useClaimControlContext } from "trellis:components/claims/context/claimControlContext"
import { useClaimGridContext } from "trellis:components/claims/context/claimGridContext"

export const UpdateClaims = () => {
  const { updateClaims, pulse } = useClaimControlContext()
  const { loading } = useClaimGridContext()

  return (
    <Tooltip
      title={Labels.updateClaims}
      mouseEnterDelay={0.5}
    >
      <VyneButton
        className={`grid-control-button ${pulse ? 'pulse' : ''}`}
        dataTestId='grid-toolbar-update-icon'
        disabled={loading}
        icon={<SyncOutlined />}
        onClick={updateClaims}
      />
    </Tooltip>
  )
}
